export const normalizeNomeBusca = (value = "") => {
  return value
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/[çÇ]/g, "C")
    .replace(/[^A-Z\s]/gi, "")
    .toUpperCase();
};